export const facebookStatisticsGroups = [
  {
    label: 'Общие',
    options: [
      {value: 'traffic_type', label: 'Тип трафика'},
      {value: 'traffic_source', label: 'Источник'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic', label: 'Блогер'},
      {value: 'inf_source', label: 'INF Поток'},
      {value: 'inf_bayer', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic', label: 'FB Кампания'},
      {value: 'fb_source', label: 'FB Поток'},
      {value: 'pixel', label: 'Пиксель'},
      {value: 'fb_bayer', label: 'FB Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser', label: 'Рекламодатель'},
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
      {value: 'offer', label: 'Оффер'},
      {value: 'landing', label: 'Лендинг'},
    ],
  },
  {
    label: 'Приложения',
    options: [
      {value: 'app', label: 'Приложение'},
      {value: 'app_service', label: 'Сервис'},
      {value: 'app_type', label: 'Платформа'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot', label: 'Бот'},
      {value: 'channel', label: 'Канал'},
      {value: 'tg_account', label: 'Телеграм Аккаунт'},
      {value: 'channel_group', label: 'Группа Каналов'},
    ],
  },
  {
    label: 'Дата',
    options: [
      {value: 'day', label: 'День'},
      {value: 'month', label: 'Месяц'},
      {value: 'year', label: 'Год'},
    ],
  },
];
